import React, { Component } from "react";
import { Link } from "react-router-dom";
import Alert from "sweetalert-react";
import * as Http from "../../../../http";
import * as Business from "../../../../utils/business";
import Loading from "../../../../components/Loading";
import moment from "moment";
import {
  ProgressBar,
  MenuItem,
  DropdownButton,
  FormGroup,
  FormControl,
  InputGroup,
  Button,
} from "react-bootstrap";
import DatePicker from "../../../../components/Forms/ExtendedForms/DatePicker";

const dicSearchOptions = {
  report_date: "Report Date",
  file_name: "Report Name",
  upload_by: "Uploader",
  approval_by: "Approver",
};

class FileManagement extends Component {
  fromDate = moment().local().startOf("day");
  toDate = moment().local().endOf("day");
  interval = null;
  state = {
    searchOption: "report_date",
    searchValue: "",
    items: [],
    loading: true,
    datePickerDisplay: {
      startDate: this.fromDate,
      endDate: this.toDate,
    },
    fromDate: this.fromDate.valueOf(),
    toDate: this.toDate.valueOf(),
  };

  reportWillDeleteObj = null;

  componentDidMount() {
    this.getUploadManagement();
    this.interval = setInterval(() => {
      this.getUploadManagement();
    }, 5000);
  }
  componentWillUnmount() {
    this.interval && clearInterval(this.interval);
  }

  getUploadManagement = () => {
    Http.getUploadManagement(Business.COMPONENT.ICAAP, null).then((data) => {
      if (data && data.Success) {
        let listData = [];
        for (let index = 0; index < data.Data.length; index++) {
          const element = data.Data[index];
          if (element && element.file_name.startsWith("ICAAP")) {
            element.timestamp = new Date(element.upload_time).getTime();
            listData.push(element);
          }
        }
        listData = listData.sort((a, b) => {
          return b.timestamp - a.timestamp;
        });
        this.setState({
          items: listData,
          loading: false,
        });
      }
    });
  };

  search = () => {
    const objSearch = {
      report_date:
        this.state.searchOption === "report_date"
          ? this.state.searchValue
          : null,
      file_name:
        this.state.searchOption === "file_name" ? this.state.searchValue : null,
      upload_by:
        this.state.searchOption === "upload_by" ? this.state.searchValue : null,
      approval_by:
        this.state.searchOption === "approval_by"
          ? this.state.searchValue
          : null,
    };

    Http.getUploadManagement(Business.COMPONENT.ICAAP, objSearch).then(
      (data) => {
        if (data && data.Success) {
          let listData = [];
          for (let index = 0; index < data.Data.length; index++) {
            const element = data.Data[index];
            if (element && element.file_name.startsWith("ICAAP")) {
              element.timestamp = new Date(element.upload_time).getTime();
              listData.push(element);
            }
          }
          listData = listData.sort((a, b) => {
            return b.timestamp - a.timestamp;
          });
          this.setState({
            items: listData,
            loading: false,
          });
        }
      }
    );
  };

  deleteListItems = () => {
    Http.deleteListReport(
      Business.COMPONENT.ICAAP,
      this.reportWillDeleteObj
    ).then((res) => {
      if (res.Success) {
        this.getUploadManagement();
      }
    });
    this.reportWillDeleteObj = null;
  };

  onDelete = (reportName, reportDate) => {
    this.reportWillDeleteObj = {
      file_name: reportName,
      report_date: reportDate,
    };
    this.setState({
      showDeleteAlert: true,
    });
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      Business.isHasRole([Business.ROLE_DEFINE_MAP.ICAAP_VIEW_REPORT]) && (
        <div className="card">
          <div className="header" style={{ gap: 16 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                color: "#757575",
                fontSize: 16,
              }}
            >
              <p style={{ marginBottom: 0 }}>LIQUIDITY RATIO</p>
              <p style={{ marginBottom: 0 }}>/</p>
              <p style={{ marginBottom: 0 }}>LCR</p>
              <p style={{ marginBottom: 0 }}>/</p>
              <p style={{ color: "#BF6A02", marginBottom: 0 }}>
                File Management
              </p>
            </div>
            <h4 className="title">File Management</h4>
          </div>
          <div
            className="content table-responsive table-full-width"
            style={{ minHeight: 400 }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "top",
                gap: 8,
              }}
            >
              <input
                type="text"
                style={{
                  height: "44px",
                  flex: 1,
                  backgroundColor: "#ffffff",
                  border: "1px solid #D9D9D9",
                  borderRadius: 8,
                }}
                className="form-control"
                id="search_value"
                onChange={(event) => {
                  this.setState({ searchValue: event.target.value });
                }}
                placeholder="Search report name"
              />
              <div className="date-picker-container">
                <DatePicker
                  isHideSearchText={true}
                  datePickerDisplay={this.state.datePickerDisplay}
                  getDate={this.getDateFromDatePicker}
                  isHideSearchButton={true}
                  style={{ height: 40 }}
                />
              </div>
              <button
                type="button"
                disabled={this.state.progressValue > 0}
                className="btn btn-primary"
                style={{
                  color: "#1E1E1E",
                  backgroundColor: "#E3E3E3",
                  borderRadius: "8px",
                  fontSize: 16,
                  fontWeight: 400,
                  marginLeft: "auto",
                  float: "left",
                  height: "44px",
                  border: "1px solid #767676",
                }}
                onClick={() => this.search()}
              >
                {" "}
                <i
                  className="pe-7s-search"
                  style={{ fontSize: 16, marginRight: 8 }}
                ></i>
                Search
              </button>
            </div>
            <table className="table table-hover table-striped">
              <thead>
                <tr>
                  <th>Report Date</th>
                  <th>Report Name</th>
                  <th>Status</th>
                  <th>Action</th>
                  <th>Uploader</th>
                  <th>Upload Time</th>
                  <th>Approver</th>
                  <th>Approval Time</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.state.items.map((item) => (
                  <tr key={item.file_name}>
                    <td>{Business.convertToDate(item.report_date)}</td>
                    <td>
                      <Link
                        to={{
                          pathname: `/icaap/file-info/${Business.convertToDate(
                            item.report_date
                          )}/${item.file_name}`,
                          state: item,
                        }}
                        style={{ color: "blue" }}
                      >
                        {Business.convertReportName(
                          item.file_name || "",
                          "ICAAP"
                        )}
                      </Link>
                    </td>
                    <td>
                      <div
                        style={{
                          backgroundColor: "#EEF4FF",
                          color: "#3538CD",
                          border: "1px solid #C7D7FE",
                          padding: "2px 8px",
                          fontSize: 12,
                          lineHeight: "18px",
                          fontWeight: 500,
                          borderRadius: 16,
                          textAlign: "center",
                        }}
                      >
                        {Business.convertFileStatus(item.status)}
                      </div>
                    </td>
                    <td>{Business.convertUploadType(item.upload_type)}</td>
                    <td>{item.upload_by}</td>
                    <td>{Business.convertToFullDate(item.upload_time)}</td>
                    <td>{item.approval_by}</td>
                    <td>{Business.convertToFullDate(item.approval_time)}</td>
                    <td className="text-right">
                      <div className="buttons-container">
                        {Business.isHasRole([
                          Business.ROLE_DEFINE_MAP.ICAAP_DELETE_REPORT,
                        ]) ? (
                          <a
                            rel="tooltip"
                            aria-disabled="true"
                            className="btn btn-info btn-simple btn-xs delete-button"
                            data-original-title="View Profile"
                            onClick={() =>
                              this.onDelete(item.file_name, item.report_date)
                            }
                          >
                            <i
                              style={{ fontSize: 20, color: "#535862" }}
                              className="pe-7s-trash"
                            ></i>
                          </a>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Alert
            title="Are you sure?"
            show={this.state.showDeleteAlert}
            text="You will not be able to recover this report!"
            showCancelButton
            onConfirm={() => {
              this.setState({ showDeleteAlert: false });
              this.deleteListItems();
            }}
            onCancel={() => {
              this.setState({ showDeleteAlert: false });
              this.reportWillDeleteObj = null;
            }}
          />
        </div>
      )
    );
  }
}

export default FileManagement;



// WEBPACK FOOTER //
// ./src/pages/LiquidityRatio/LCR/FileManagement/FileManagement.js